module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/item-10-3d89d23a8e788e6986a620c9ee11dbb7.jpg";